var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"value":_vm.isSnackbarShown},on:{"input":_vm.hideMessage}},[_vm._v(" "+_vm._s(_vm.currentMessage.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }